import { $$$ } from '@suntex.core/text';
import { asPath } from '@suntex.core/text/extensions';

/** Annotate `href` with a `from` query param (the location navigated from). */
export function withFromParam(href: string, from: string | undefined): string {
  return from ? $$$(href, asPath()).withParams({ from }).$$ : href;
}
